<template>
  <div>
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">返回首页</router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <!-- 一级标题 -->
      <h2 class="title1">钥匙</h2>

      <div class="container-content">
        <h3 class="title2">点火钥匙</h3>
        <p><span class="textWhiteBGBlack">CH型</span></p>
        <p>务必记录钥匙编号牌上的钥匙编号，并将其记录在本手册中。将备用钥匙妥善存放。若要复制钥匙，请将备用钥匙或钥匙编号带给经销商。<br />如果丢失了所有钥匙和钥匙编号，经销商可能必须卸下点火开关总成才能确定钥匙编号。</p>
        <p>金属钥匙座可能会损坏点火开关周围的区域。</p>

        <h3 class="title2">应急钥匙</h3>
        <p><span class="textWhiteBGBlack">CH型除外</span>
        <p>应急钥匙用于紧急情况
          <ul class="circle"><li><router-link to="/block31b/jqxjs">解锁鞍座</router-link></li></ul>
          <ul class="circle"><li><router-link to="/block31c/yingjiqingk">解锁点火开关</router-link></li></ul>
        </p>
        <p>请勿将应急钥匙存放在衣帽箱中。</p>

        <img src="./img/p1201.png" width="100%" />

        <h3 class="title2">本田智能钥匙</h3>
        <p><span class="textWhiteBGBlack">CH型除外</span></p>
        <p>携带本田智能钥匙时可执行以下操作
          <ul class="circle">
            <li>锁定或解锁点火开关</li>
            <li>解开鞍座锁</li>
            <li>锁定或解锁转向</li>
          </ul>
        </p>
        <p>本田智能钥匙的 ID 号码位于 ID 标签牌上。您还可以通过输入 ID 号码来解锁点火开关。</p>
        <p>请务必同时携带应急钥匙和 ID 标签牌，但需与本田智能钥匙分开放置，以防同时全部丢失。</p>
        <p>此外，请在摩托车外的其他安全场所保存一份 ID 号码的副本。</p>
        <div class="warningbox">
          <div class="top">
            <span>警告</span>
          </div>

          <div class="line">
            <p>请妥善保管好 ID 标签牌和 ID 号码，若他人获知 ID 标签牌和 ID 号码，车辆存在被盗风险。</p>
          </div>
        </div>
        <p>本田智能钥匙中含有由本田智能钥匙系统激活的电子电路。如果该电路损坏，本田智能钥匙将无法执行任何操作。</p>
        <ul class="circle">
          <li>请勿掉落本田智能钥匙或在其上放置重物。</li>
          <li>请让本田智能钥匙远离直射阳光、高温和高湿环境。</li>
          <li>请勿刮擦或穿刺本田智能钥匙。</li>
          <li>请勿存放在磁性产品（如磁性钥匙链）附近。</li>
          <li>请将本田智能钥匙远离电器产品（如电视机、收音机、计算机或低频按摩仪）。</li>
          <li>请使本田智能钥匙远离液体。如果智能钥匙变湿，请立即使用软布将其擦干。</li>
          <li>清洗摩托车时，请将本田智能钥匙带离摩托车。</li>
          <li>请勿焚烧本田智能钥匙。</li>
          <li>请勿使用超音波清洗器进行清洗。</li>
          <li>如果本田智能钥匙上粘附了燃料、蜡油或油脂，请立即将其擦净，以防智能钥匙开裂或变形。</li>
          <li>除需更换电池外，请勿拆解本田智能钥匙。仅能拆解本田智能钥匙的外壳。请勿拆解其他零件。</li>
          <li>请勿弄丢您的本田智能钥匙。如果丢失，则需要注册新的本田智能钥匙。请携应急钥匙和 ID 标签牌前往经销商处进行注册。</li>
          <li>如果您的本田智能钥匙和 ID 标签全部丢失，请联系经销商进行处理。</li>
        </ul>
        <p>本田智能钥匙系统中的电池通常可使用约 2 年的时间。</p>
        <p>请勿在行李箱中存放无线电发射设备。从这些设备发出的无线电频率会中断本田智能钥匙系统。</p>
        <p>若要获取额外的本田智能钥匙，请携本田智能钥匙骑车前往经销商处办理。</p>
        <img src="./img/p1202.png" width="100%" />
        <!-- 锚点定位 -->
        <h3 class="title2">仅限中国</h3>
        <p>
            ECU<br>
            设备目录：通用微功率设备 A类设备<br>
            使用频率：9-190kHz<br>
            10米处磁场强度：不大于72dBμA/m，每倍频程下降3dB（准峰值检波）<br>
            使用场景：摩托车用<br>
            使用时温度： -20°C ~ +60°C<br>
            使用时电压的环境条件：DC12V<br>
            采用的天线类型：线圈天线<br>
            
        </p>
        <p>
            FOB<br>
            设备目录：通用无线遥控设备<br>
            使用频率：433.05-434.79MHz<br>
            发射功率限值：10mW(e . r. p)<br>
            占用带宽：不大千400kHz<br>
            使用场景：摩托车用<br>
            使用时温度：-20°C ~ +80°C<br>
            使用时电压的环境条件： DC3V<br>
            采用的天线类型：图案天线<br>
            天线增益：-20dBi<br>
        </p>
        <ul class="circle">
          <li>不得擅自改变使用场景或使用条件、 扩大发射频率范围、 加大发射功率（包括额外加装射频功率放大器）， 不得擅自更改发射天线；</li>
          <li>不得对其他合法的无线电台（站）产生有害干扰， 也不得提出免受有害干扰保护； </li>
          <li>应当承受辐射射频能量的工业、 科学及医疗 (ISM)应用设备的干扰或其他合法的无线电台（站）干扰； </li>
          <li>如对其他合法的无线电台（站）产生有害干扰时， 应立即停止使用，并采取措施消除干扰后方可继续使用； </li>
          <li>在航空器内和依据法律法规、国家有关规定、标准划设的射电天文台、 气象雷达站、 卫星地球站（含测控、 测距、 接收、 导航站）等军民用无线电台（站）、 机场等的电磁环境保护区域内使用微功率设备， 应当遵守电磁环境保护及相关行业主管部门的规定； </li>
          <li>禁止在以机场跑道中心点为圆心、 半径5000米的区域内使用各类模型遥控器；</li>
          <li>使用微功率短距离无线电发射设备应当符合国家无线电管理有关规定。</li>
        </ul>
      </div>
      <!-- 上一页 下一页 -->
      <div class="foot-btn clearfix">
        <div class="prev">
          <router-link to="/block34">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block36">下一页</router-link>
        </div>
      </div>
      <!-- 上一页 下一页 -->
    </div>
    <!-- 内容 -->
  </div>
</template>

<script>
export default {
  props: ["id"],
  watch: {
    $route(to, from) {
      if (this.id != null) {
        setlink(this);
      }
    }
  },
  mounted() {
    setlink(this);
    // 图像热区
    // //imagehoverclick("boxmap");
  },
  methods: {
    goto(path) {
      this.$router.push({ path: path });
    }
  }
};
</script>
